class UtilClass {
    toList(inputList, className) {
        const result = [];
        for (let index in inputList) {
            result.push(new className(inputList[index]));
        }
        return result;
    }

    isValidURL(urlString) {
        let url;

        try {
            url = new URL(urlString);
        } catch (_) {
            return false;
        }

        return url.protocol === "http:" || url.protocol === "https:";
    }

    getErrorJson(errorMessage) {
        return { 'error': errorMessage }
    }

    isValidEmail(input) {
        return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(input);
    }

    // yyyy-mm-dd
    isValidDate(input) {
        return /\d{4}-\d{2}-\d{2}/.test(input)
    }

    // yyyy-mm-ddThh:mm:ssZ
    isValidDateTime(input) {
        return /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\+|-)\d{2}:\d{2}/.test(input)
    }

    isNumber(input) {
        return !isNaN(parseFloat(input)) && !isNaN(input - 0)
    }
}

export const Util = new UtilClass();
Object.freeze(Util)